import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './main.component';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { Notfound404Component } from './notfound404/notfound404.component';
import { Forbidden403Component } from './forbidden403/forbidden403.component';
import { ShipmentsComponent } from './shipments/shipments.component';
import { AddEditShipmentComponent } from './shipments/add-edit-shipment/add-edit-shipment.component';
import { ViewShipmentComponent } from './shipments/view-shipment/view-shipment.component';
import { RateSetupComponent } from './rate-setup/rate-setup.component';
import { SaleOrderComponent } from './sale-order/sale-order.component';
import { ReportComponent } from './report/report/report.component';
import { ProductComponent } from './product/product.component';


const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'shipments',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule)
      },
      {
        path: 'shipments',
        component: ShipmentsComponent
      },
      {
        path: 'sale-orders',
        component: SaleOrderComponent
      },
      {
        path: 'packing-slip',
        component: ReportComponent
      },
      {
        path: 'rates-setup',
        component: RateSetupComponent
      },{
        path: 'product',
        component: ProductComponent
      },
      {
        path: 'addEditShipment',
        component: AddEditShipmentComponent
      },
      {
        path: 'viewShipment',
        component: ViewShipmentComponent
      },
      {
        path: '404',
        component: Notfound404Component
      },
      {
        path: '403',
        component: Forbidden403Component
      },
      {
        path: '**',
        redirectTo: '404'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainRoutingModule { }
